"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProperty = exports.isObject = void 0;
const reactiveState_constants_1 = require("./reactiveState.constants");
const isObject = (item) => !!(item && typeof item === 'object' && item.constructor === Object);
exports.isObject = isObject;
const setProperty = (target, prop, value) => Object.assign(target, { [prop]: { [reactiveState_constants_1.VALUE]: value } });
exports.setProperty = setProperty;
//# sourceMappingURL=reactiveState.utils.js.map